var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpandCircleDownOutlined(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 20C7.45614 20 4 16.5439 4 12C4 7.45614 7.45614 4 12 4C16.5439 4 20 7.45614 20 12C20 16.5439 16.5439 20 12 20ZM12 22C17.5263 22 22 17.5263 22 12C22 6.47368 17.5263 2 12 2C6.47368 2 2 6.47368 2 12C2 17.5263 6.47368 22 12 22ZM12.7018 13.2982L9.70175 10.2982C9.52632 10.1053 9.2807 10 9 10C8.45614 10 8 10.4561 8 11C8 11.2807 8.10526 11.5263 8.29825 11.7018L11.2982 14.7018C11.4737 14.8947 11.7193 15 12 15C12.5439 15 13 14.5439 13 14C13 13.7193 12.8947 13.4737 12.7018 13.2982ZM14.2982 10.2982L11.2982 13.2982C11.1053 13.4737 11 13.7193 11 14C11 14.5439 11.4561 15 12 15C12.2807 15 12.5263 14.8947 12.7018 14.7018L15.7018 11.7018C15.8947 11.5263 16 11.2807 16 11C16 10.4561 15.5439 10 15 10C14.7193 10 14.4737 10.1053 14.2982 10.2982Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandCircleDownOutlined);
export default __webpack_public_path__ + "static/media/expand_circle_down_outlined.3ecb5e25.svg";
export { ForwardRef as ReactComponent };